<div 
  [ngClass]="{
    'iframe-fullscreen': (iframeMode !== IframeMode.NONE || isIframeMode),
    'standalone-fullscreen': hideCloseButton,
    'fixed w-full xs:w-[24rem] h-[calc(100vh-6rem)] rounded-t-2xl xs:rounded-2xl inset-x-0 bottom-0 xs:inset-x-auto xs:right-6 xs:bottom-10 shadow-xl': !hideCloseButton && (iframeMode === IframeMode.NONE && !isIframeMode)
  }"
  class="flex flex-col bg-[var(--chatBotBgColor)] pointer-events-auto">
  
  <div *ngIf="iframeMode !== IframeMode.INLINE" class="w-full h-14 border-b flex items-center justify-between p-3">
    <div class="flex justify-start items-center gap-2">
      <img
        *ngIf="chatBotStyles.companyLogo"
        [src]="chatBotStyles.companyLogo"
        alt="company logo"
        class="h-8 w-8 object-contain" 
      />
      <span class="text-sm font-semibold text-[var(--colorDefault)] font-['Open_Sans']">AI Service Booking</span>
    </div>
    <div *ngIf="!hideCloseButton" class="flex gap-2 justify-end items-center">
      <button
        *ngIf="isInlineMode(); else closeButton"
        type="button"
        class="rounded-lg text-sm inline-flex items-center text-[var(--colorDefault)]"
        (click)="refreshIframe()"
      >
        <img src="assets/images/refresh_icon.svg" alt="Refresh" class="h-5 w-5 object-contain" />
      </button>

      <ng-template #closeButton>
        <button
          type="button"
          class="rounded-lg text-sm inline-flex items-center text-[var(--colorDefault)]"
          (click)="closeChatModal()"
        >
          <img src="assets/images/close_icon.svg" alt="Close" class="h-5 w-5 object-contain" />
        </button>
      </ng-template>
    </div>
  </div>

  <div class="flex flex-col flex-1 min-h-0 w-full">
    <app-chat-bubble #chatBubble class="flex-1 flex min-h-0" [ngClass]="{'hidden': isWelcomeScreen}" [isWelcomeScreen]="isWelcomeScreen"></app-chat-bubble>
    <app-chat-welcome class="flex-1 flex overflow-y-auto min-h-0" [ngClass]="{'hidden': !isWelcomeScreen}"></app-chat-welcome>
  </div>
</div>